import React from "react";
import styles from "./LongArrow.module.scss";
import cx from "classnames";
import { IconSizes } from "../../../enums/icon-sizes";
import SVGContainer from "../../commons/svg-container/SVGContainer";

interface Props {
  icon: React.ReactNode;
  onClick: () => void;
  className?: string;
  disabled?: boolean;
}

const LongArrow: React.FC<Props> = (props: Props) => {
  return (
    <button
      onClick={props.onClick}
      className={cx(styles.LongArrow, props.className ?? "")}
      disabled={props.disabled}
    >
      <SVGContainer
        iconSize={IconSizes.IC__longArrow}
        className={cx(styles.icon, props.disabled && styles.icon__disabled)}
      >
        {props.icon}
      </SVGContainer>
    </button>
  );
};

export default LongArrow;
